import { render, staticRenderFns } from "./OrderSummaryNew.vue?vue&type=template&id=6b629bcb&scoped=true&"
import script from "./OrderSummaryNew.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryNew.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSummaryNew.vue?vue&type=style&index=0&id=6b629bcb&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b629bcb",
  null
  
)

export default component.exports